'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils = require('./utils-40e27a2a.js');

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

const _getToUrl = (projectName, $to) => {
    let prefix = '';
    if (projectName === 'dashboard-ui') {
        prefix = '/#';
    }
    else if (projectName === 'dashboard-ui-accounts') {
        prefix = '/account';
    }
    const url = $to.path.reduce((acc, { url }) => `${acc}${(url === null || url === void 0 ? void 0 : url.pattern) || ''}`, prefix);
    return url;
};
const runDeprecationMiddleware = ($transitions, $injector, options = {}) => {
    utils.debugLog('Project name:', options.projectName);
    $transitions.onBefore({}, function (trans) {
        return callMiddleware('deprecationMiddleware', trans);
    });
    function callMiddleware(middleWare, transition) {
        try {
            return $injector.get(middleWare).run(transition, options);
        }
        catch (e) {
            console.error('The factory : ' + middleWare + ' does not exist');
        }
    }
};
function deprecationMiddleware() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const deprecationMiddleware = this;
    deprecationMiddleware.run = function (trans, { projectName, deprecationManifestForDev, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const Account = trans.injector().get('Account');
            const User = trans.injector().get('User');
            const $to = trans.$to();
            const toUrl = _getToUrl(projectName, $to);
            const params = trans.params();
            utils.debugLog(`Transition url: ${toUrl}`);
            let manifest;
            let currentAccount;
            let currentUser;
            try {
                manifest = deprecationManifestForDev || (yield utils.fetchDeprecationManifest());
                currentUser = yield User.getCurrent();
                currentAccount = yield Account.getCurrent();
            }
            catch (e) {
                console.error(e.message);
            }
            utils.checkUrlForDeprecation({ toUrl, currentAccount, currentUser, manifest, params });
        });
    };
    return {
        run: deprecationMiddleware.run,
    };
}

exports.deprecationMiddleware = deprecationMiddleware;
exports.runDeprecationMiddleware = runDeprecationMiddleware;
